declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { HCPService } from '../../../../services/hcp.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ActorLegalInfoRequest, ActorLegalInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppData } from '../../../../models/appdata';
import { DBOperation } from '../../../../enums/enum';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NgbLegalInfoModal } from './modals/legalinfo.modal';
import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';



@Component({
  selector: 'legalinfo',
  templateUrl: './legalinfo.component.html',
  styleUrls: ['./legalinfo.component.scss']
})

export class LegalInfoComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() CanShowRegistryView: number;

  public isRequesting: boolean = false;

  CurrentActorLegalInfoRequest: ActorLegalInfoRequest;
  CurrentActorLegalInfoController: ActorLegalInfoController[];

  public ApiResData: ApiResponseModel;
  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal) { }

  ngOnInit() {

    this.CurrentActorLegalInfoRequest = new ActorLegalInfoRequest();
    this.CurrentActorLegalInfoController = new Array<ActorLegalInfoController>();
    this.CurrentActorLegalInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorLegalInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.CanShow === 1 || this.CanShowRegistryView === 1) {
      this.GetActorLegalInfoController();
    }

  }

  GetActorLegalInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorLegalInfoController(this.CurrentActorLegalInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
       
          this.CurrentActorLegalInfoController = this.ApiResData.Result;
         this.initGridButton();

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }




 
  isREADONLY: boolean = false;
  exportFileName: string = "ActorLegalInfoList_";
  dbops: DBOperation;
  columns: any[] = [
    {
      display: 'Charge',
      variable: 'Charge',
      filter: 'text',
    },
    {
      display: 'Charge Date',
      variable: 'ChargeDate',
      filter: 'date'
    },
    {
      display: 'Reason',
      variable: 'Reason',
      filter: 'text'
    }
 
  ];
  sorting: any = {
    column: 'ChargeDate',
    descending: false
  };
  hdrbtns: any[] = [];
  gridbtns: any[] = [];
  initGridButton() {

    this.hdrbtns = [
      {
        title: 'Add',
        keys: [''],
        action: DBOperation.create,
        ishide: false

      }];
    this.gridbtns = [

      {
        title: 'XX',
        keys: ["LegalCode"],
        action: DBOperation.delete,
        ishide: false
      },
      {
        title: 'Detail',
        keys: ["LegalCode"],
        action: DBOperation.detail,
        ishide: false
      },
      {
        title: 'Doc',
        keys: ["ActorDocCode"],
        action: DBOperation.doc,
        ishide: false
      },

    ];

  }

    gridaction(gridaction: any): void {

    switch (gridaction.action) {
      case DBOperation.create:
        this.openNewContent();
        break;
    
      case DBOperation.delete:
       
 
      
      //  this.DeleteLegalInfoByCode(gridaction.values[0].value);
     
        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0CC27E',
          cancelButtonColor: '#FF586B',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonClass: 'btn btn-success btn-raised mr-5',
          cancelButtonClass: 'btn btn-danger btn-raised',
          buttonsStyling: false
        }).then(() =>{

         

          this.DeleteLegalInfoByCode(gridaction.values[0].value);
         
        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              'Delete Operation Cancelled :)',
              'error'
            )
          }
        }) 
      
        break;
      case DBOperation.detail:
        this.OpenDetailContent(gridaction.values[0].value);
        break;
      case DBOperation.doc:
        this.openDocContent(gridaction.values[0].value);

        break;
    
    }
    }

    del_(LegalCode: any) {

      swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0CC27E',
        cancelButtonColor: '#FF586B',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        confirmButtonClass: 'btn btn-success btn-raised mr-5',
        cancelButtonClass: 'btn btn-danger btn-raised',
        buttonsStyling: false
      }).then(() => {



        this.DeleteLegalInfoByCode(LegalCode);

      }, function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          swal(
            'Cancelled',
            'Delete Operation Cancelled :)',
            'error'
          )
        }
      }) 
    }
   DeleteLegalInfoByCode(LegalCode: any) {

    

    this.StartRefreshing();
    this.CurrentActorLegalInfoRequest.ConditionalOperator = 3;
    this.CurrentActorLegalInfoRequest.LegalCode = LegalCode;
    this.hcpservice.SaveActorLegalInfo(this.CurrentActorLegalInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

        

           // alertFunctions.AlertParam('Saved Successfully.....!');
             swal(
            'Deleted!',
            'Delete Operation Completed Successfully.',
            'success'
          )


            this.stopRefreshing();
            this.GetActorLegalInfoController();
         

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  openNewContent() {
    const modalRef = this.modalService.open(NgbLegalInfoModal)
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.result.then(x => { this.GetActorLegalInfoController() })

  }
  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'
      };
      const modalRef = this.modalService.open(NgbActorDocsModal,options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = ActorDocCode;
      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;
      //modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }

  OpenDetailContent(LegalCode: any) {

    var CurrentActorLegalInfoControllerByCode = this.CurrentActorLegalInfoController.filter(x => x.LegalCode === parseInt(LegalCode));
    if (CurrentActorLegalInfoControllerByCode.length > 0) {
      const modalRef = this.modalService.open(NgbLegalInfoModal);
      modalRef.componentInstance.IsShowDetail = true;
      modalRef.componentInstance.ActorCode = this.ActorCode;
      modalRef.componentInstance.CurrentActorLegalInfoControllerByCode = CurrentActorLegalInfoControllerByCode[0];


    }
    else {
      alertFunctions.AlertParam('No Data Exits....!S');
    }

  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
